import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SobreNosTabContextType {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const SobreNosTabContext = createContext<SobreNosTabContextType | undefined>(undefined);

interface SobreNosTabProviderProps {
  children: ReactNode;
}

export const SobreNosTabProvider: React.FC<SobreNosTabProviderProps> = ({ children }) => {
  const [activeTab, setActiveTab] = useState<string>('sobre-nos-historia');

  return (
    <SobreNosTabContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </SobreNosTabContext.Provider>
  );
};

export const useSobreNosTab = (): SobreNosTabContextType => {
  const context = useContext(SobreNosTabContext);
  if (!context) {
    throw new Error('useSobreNosTab must be used within SobreNosTabProvider');
  }
  return context;
};
